import { createApp } from 'vue';
import { createI18n } from 'vue-i18n';
import PathwaysBlock from './pathwaysblock/PathwaysBlock.vue';
import { messages } from './i18n';

function initPathwaysBlock() {
  const i18n = createI18n({
    legacy: false,
    locale: document.documentElement.getAttribute('lang') || 'en',
    fallbackLocale: 'en',
    messages,
  });

  const mountPoint = document.getElementById('epb-pathways-block');

  if (mountPoint) {
    const app = createApp(PathwaysBlock);
    app.use(i18n);
    app.mount(mountPoint);
  } else {
    console.warn('[PathwaysBlock] No mount point #epb-pathways-block found');
  }
}

// Try to init immediately, or wait for DOM, or use MutationObserver for BigPipe
function tryInit() {
  const mountPoint = document.getElementById('epb-pathways-block');
  if (mountPoint) {
    initPathwaysBlock();
    return true;
  }
  return false;
}

// Immediate try
if (!tryInit()) {
  // Wait for DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      if (!tryInit()) {
        // Still not found - use MutationObserver for BigPipe lazy loading
        observeForMountPoint();
      }
    });
  } else {
    // DOM ready but element not found - use MutationObserver
    observeForMountPoint();
  }
}

function observeForMountPoint() {
  const observer = new MutationObserver((mutations, obs) => {
    if (tryInit()) {
      obs.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // Timeout after 10 seconds
  setTimeout(() => {
    observer.disconnect();
    console.warn('[PathwaysBlock] Gave up waiting for mount point after 10s');
  }, 10000);
}
